<h3 kb-heading>{{heading}}</h3>
<ng-content></ng-content>
